var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVesselOffline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 46,
    viewBox: "0 0 41 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2451_24145)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2451_24145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9092 11.4635C13.9092 10.9435 14.0743 10.437 14.3807 10.0169L18.4716 4.40868C19.452 3.06462 21.4572 3.06462 22.4377 4.40868L26.5286 10.0169C26.835 10.437 27.0001 10.9435 27.0001 11.4635V36.8389C27.0001 37.4898 26.7532 38.1306 26.2289 38.5164C23.0669 40.8424 17.7336 40.7313 14.6824 38.5135C14.1559 38.1307 13.9092 37.4898 13.9092 36.8389V11.4635Z",
    fill: "#F0533E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1821 11.4634V36.8388C26.1821 37.2998 26.0082 37.6631 25.7442 37.8573C24.3375 38.8921 22.3982 39.4141 20.4198 39.4006C18.4406 39.3873 16.5216 38.8387 15.1636 37.8516C14.9015 37.661 14.7275 37.3005 14.7275 36.8388V11.4634C14.7275 11.1167 14.8376 10.7791 15.0419 10.4991L19.1328 4.89078C19.7864 3.99474 21.1233 3.99474 21.7768 4.89077L25.8677 10.4991C26.072 10.7791 26.1821 11.1167 26.1821 11.4634Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.5347 19.4543C16.5347 19.1058 16.6459 18.7664 16.8522 18.4855L19.1356 15.3767C19.7895 14.4864 21.1194 14.4864 21.7733 15.3767L24.0567 18.4855C24.263 18.7664 24.3742 19.1058 24.3742 19.4543V35.4943C24.3742 35.985 24.1609 36.4624 23.7387 36.7126C21.7718 37.8781 18.9078 37.9161 17.0878 36.7073C16.7124 36.458 16.5347 36.0141 16.5347 35.5634V19.4543Z",
    fill: "#C12B17"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2451_24145",
    x: 9.90918,
    y: 1.40063,
    width: 21.0908,
    height: 44.8186,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2451_24145"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2451_24145",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2451_24145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.9091,
    height: 45,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVesselOffline);
export default __webpack_public_path__ + "static/media/vessel-offline.fd4b3a4d5b30b20f29f91a35b8fa71d1.svg";
export { ForwardRef as ReactComponent };